export default __webpack_public_path__ + "static/media/scrabble-go.14871737.webp";